import styled from 'styled-components';

const Blur = styled.div<{blurRadius?: number}>`
  filter: blur(${props => props.blurRadius || 5}px);
`;

export default Blur;